import { render, staticRenderFns } from "./courierModal.vue?vue&type=template&id=0da47f4a"
import script from "./courierModal.vue?vue&type=script&lang=js"
export * from "./courierModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports